var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSheetinline = function SvgSheetinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.526 18 8.931 1h13.543l-7.405 17H1.526Z",
    stroke: "#fff",
    strokeWidth: 2
  })));
};

export default SvgSheetinline;